<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="column full-width">
      <div class="col">
        <q-input
          ref="inputRef"
          :value="formattedValue"
          dense
          outlined
          :placeholder="placeholder"
          bg-color="white"
          :readonly="disabled"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
import { useCurrencyInput } from 'vue-currency-input'
import { watch } from 'vue'

export default {
  components: {
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  setup (props) {
    const precision = Number(props.configs?.precision || 2)
    const modelValue = props.value

    const {
      inputRef,
      formattedValue,
      setValue
    } = useCurrencyInput({
      locale: 'de-DE',
      currency: 'BRL',
      precision,
      modelValue,
      useGrouping: true,
      currencyDisplay: 'hidden',
      exportValueAsInteger: false,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false
    })

    watch(
      () => props.value,
      (value) => {
        setValue(value)
      }
    )

    return { inputRef, precision, formattedValue }
  },

  computed: {
    placeholder () {
      return this.configs?.placeholder
    }
  }
}

</script>
